import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Typography, IconButton } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { scroller } from "react-scroll";
import cover from "../../assets/images/cover.jpg";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage: "url(" + cover + ")",
        backgroundBlendMode: "overlay",
        backgroundSize: "cover",
    },
    header: {
        fontFamily: "Raleway",
        color: "white",
        paddingTop: "20px",
    },
    subtitle: {
        fontFamily: "Raleway",
        color: "white",
        fontSize: "18px",
    },
    expandButton: {
        marginTop: "20px",
        color: "#000000",
        zIndex: 2,
    },
});

export const Home: React.FC = () => {
    const classes = useStyles();

    const handleExpandClick = () => {
        scroller.scrollTo("about", {
            duration: 1500,
            delay: 100,
            smooth: true,
        });
    };

    return (
        <Box id="home">
            <Box className={classes.root}>
                <Typography variant="h2" className={classes.header}>
                    Tony Power
                </Typography>
                <Typography variant="subtitle1" className={classes.subtitle}>
                    Chimney Cleaning
                </Typography>
                <IconButton
                    className={classes.expandButton}
                    onClick={handleExpandClick}
                >
                    <ExpandMore fontSize="large" />
                </IconButton>
            </Box>
        </Box>
    );
};
